import type { Locale } from 'date-fns';

/**
 * Browser / OS IANA timezone. Use when user preference is unavailable (logged out or fetch failed).
 */
export function getBrowserTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/**
 * Options for `startOfWeek` / `endOfWeek` so week boundaries follow the active date-fns locale
 * (e.g. en-US: Sunday–Saturday, en-GB / most EU: Monday–Sunday).
 */
export function dateFnsWeekLocaleOptions(locale: Locale): { locale: Locale } {
  return { locale };
}
